// This icon file is generated automatically.
var MinusOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "clip-rule": "evenodd", "d": "M5 11.5c0-.41.34-.75.75-.75h11.5a.75.75 0 110 1.5H5.75A.75.75 0 015 11.5z", "fill-rule": "evenodd" } }] }, "name": "minus", "theme": "outlined" };
export default MinusOutlined;
